<span class="material-icons-outlined" *ngIf="!startRecognition" (click)="startStopVoiceRecognition()">mic_none</span>
<span class="material-icons-outlined" *ngIf="startRecognition" (click)="startStopVoiceRecognition()">mic_off_outlined</span>
